export const TYPES = ['observation', 'avis', 'entretien', 'prep_entretien'];
//# sourceMappingURL=comment.types.js.map